export const subReddits = [
  { name: "pics", label: "Home" },
  { name: "technology", label: "Technology" },
  { name: "science", label: "Science" },
  { name: "worldnews", label: "Worldnews" },
  { name: "politics", label: "Politics" },
  { name: "business", label: "Business" },
  { name: "education", label: "Education" },
  { name: "environment", label: "Environment" },
  { name: "finance", label: "Finance" },
  { name: "AskReddit", label: "AskReddit" },
  { name: "space", label: "Space" },
  { name: "health", label: "Health" },
  { name: "food", label: "Food" },
  { name: "sports", label: "Sports" },
  { name: "music", label: "Music" },
  { name: "movies", label: "Movies" },
  { name: "books", label: "Books" },
  { name: "gaming", label: "Gaming" },
  { name: "art", label: "Art" },
  { name: "history", label: "History" },
  { name: "photography", label: "Photography" },
  { name: "travel", label: "Travel" },
  { name: "woahthatsinteresting", label: "Woah that's interesting" },
];